import * as React from "react";
import {MerchantPreferredBy} from "../../../model/job/BillOfMaterialsPreviewDetails";

interface IProps {
	/**
	 * Merchant preferences list
	 */
	merchantPreferredBy: string[];
}

export default class MerchantPreferences extends React.PureComponent<IProps> {

	render() {
		return (
			<React.Fragment>
				{this.props.merchantPreferredBy.map(this.renderPreference)}
			</React.Fragment>
		);
	}

	renderPreference = (preferredBy: string, index: number) => {
		const size = this.props.merchantPreferredBy.length;
		let text = '', cssClass = '', iconClass = '';
		if (preferredBy === MerchantPreferredBy.HIBER) {
			text = 'hiber Preferred';
			cssClass = 'green';
			iconClass = 'fa-thumbs-up';
		}
		else if (preferredBy === MerchantPreferredBy.PARTNER_BRAND) {
			text = 'Partner Preferred';
			cssClass = 'orange';
			iconClass = 'fa-star'
		}
		else if (preferredBy == MerchantPreferredBy.BOILER) {
			text = 'Preferred Boiler';
			cssClass = 'blue';
			iconClass = 'fa-info'
		}
		return <span key={index}>
			<div className={'circle-wrapper sm ' + cssClass}><i className={'fas ' + iconClass}/></div>
			<b>{text + ((index + 1) < size ? ' + ' : '')}</b>
		</span>;
	}
}